import React from "react";

export default function EmptyState({
  title = "Nothing here yet",
  subtitle,
  cta,
  testid = "empty-state",
}) {
  return (
    <div
      data-testid={testid}
      className="rounded-lg border border-dashed border-[#EAE3D2] bg-white/60 px-6 py-12 text-center"
    >
      <p className="font-display text-2xl text-[#1A1A1A]">{title}</p>
      {subtitle ? (
        <p className="mx-auto mt-3 max-w-md text-sm text-[#1A1A1A]/60">{subtitle}</p>
      ) : null}
      {cta ? <div className="mt-6">{cta}</div> : null}
    </div>
  );
}
